import { c as _c } from "react/compiler-runtime";
import React from 'react';
import NextImage, { ImageProps } from 'next/image';
import { mergeClasses } from '@/utils/style';
export function Image(props) {
  const $ = _c(12);
  let className;
  let cropHeight;
  let isRounded;
  let nextImageProps;
  if ($[0] !== props) {
    ({
      cropHeight,
      isRounded,
      className,
      ...nextImageProps
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = cropHeight;
    $[3] = isRounded;
    $[4] = nextImageProps;
  } else {
    className = $[1];
    cropHeight = $[2];
    isRounded = $[3];
    nextImageProps = $[4];
  }
  let t0;
  if ($[5] !== className || $[6] !== cropHeight || $[7] !== isRounded) {
    t0 = mergeClasses("mt-6 lg:mt-8", {
      "rounded-2xl": isRounded
    }, {
      "max-lg:w-full max-lg:object-cover": cropHeight !== undefined
    }, {
      "max-lg:h-[11.75rem]": cropHeight === "sm"
    }, {
      "max-lg:h-[20.25rem]": cropHeight === "md"
    }, {
      "max-lg:h-[25rem]": cropHeight === "lg"
    }, className);
    $[5] = className;
    $[6] = cropHeight;
    $[7] = isRounded;
    $[8] = t0;
  } else {
    t0 = $[8];
  }
  let t1;
  if ($[9] !== nextImageProps || $[10] !== t0) {
    t1 = <NextImage {...nextImageProps} className={t0} />;
    $[9] = nextImageProps;
    $[10] = t0;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  return t1;
}